import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-cream" data-id="element-177" data-mp="2lmspylv9v6kb">
      <div className="max-w-4xl mx-auto" data-id="element-178" data-mp="26yfudq03jpqc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-179" data-mp="26xmsb2c31oej">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-ink" data-id="element-180" data-mp="1xwoksa2fqyr7">
            💬 Does This Sound Familiar?
          </h2>
          <p className="text-lg text-charcoal leading-relaxed bg-white p-6 rounded-2xl border border-sage shadow-sm" data-id="element-181" data-mp="21x8jhi2nqafg">
            Sunday evening. 9 PM. You have a pickleball lesson tomorrow morning. And you&apos;re
            still here — searching online, trying to build a session structure that actually
            flows — one that fits your player&apos;s level, feels professional, and
            doesn&apos;t look like it was thrown together in twenty minutes.
            <br data-id="element-182" data-mp="1yzdlqilcs5ky" />
            <br data-id="element-183" data-mp="1yyu8hf6ne5d9" />
            <span className="text-forest font-medium" data-id="element-184" data-mp="1yyc1bnig66qk">
              Not because you don&apos;t know pickleball.
            </span>{' '}
            Because nobody ever gave you a complete, structured, ready-to-teach library.
            You&apos;ve been building every single session from scratch. The time you should
            be resting — you&apos;re spending it planning. And the worst part isn&apos;t the
            exhaustion. The worst part is walking onto the court feeling like you could have
            been better prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-185" data-mp="1p3sh0cowgr7i">
          <h3 className="text-xl font-bold text-ink mb-8 text-center" data-id="element-186" data-mp="30h4n6u84tlwu">
            The Real Cost of Not Having the Right Resource
          </h3>
          <div className="overflow-hidden rounded-xl border border-sage bg-white shadow-sm" data-id="element-187" data-mp="2vib9p1suhuwo">
            <div className="hidden sm:grid grid-cols-2 bg-forest text-xs uppercase tracking-wider font-bold text-cream-light" data-id="element-188" data-mp="1t4n3kh0n4z9s">
              <p className="px-5 py-3" data-id="element-189" data-mp="1y62tonhodvz1">The Problem</p>
              <p className="px-5 py-3 border-l border-cream/20" data-id="element-190" data-mp="2274tb5fi8a1j">The Real Impact</p>
            </div>
            {painPoints.map((point, index) => <motion.div key={point.problem} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} className="grid sm:grid-cols-2 border-t first:border-t-0 border-sage" data-id="element-191" data-mp="1aenlie37wkfv" data-mpi={index}>
                <p className="px-5 py-4 text-ink text-sm leading-relaxed" data-id="element-192" data-mp="1o7n08dv6eamd">
                  <span className="mr-2" data-id="element-193" data-mp="qrg2g2z4qqvg">❌</span>
                  {point.problem}
                </p>
                <p className="px-5 pb-4 sm:py-4 text-charcoal text-sm leading-relaxed sm:border-l border-sage" data-id="element-194" data-mp="vops9jqfl4jt">
                  <span className="mr-2 sm:hidden" data-id="element-195" data-mp="o4xdf99go9xm">💥</span>
                  {point.impact}
                </p>
              </motion.div>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-sage" data-id="element-196" data-mp="e7j55wxoyrge">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-197" data-mp="e9wxhy0zlpk9">
              Stop giving away your free time. Your dedication is already there. What you
              need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-ink" data-id="element-198" data-mp="g5nypn9a5oj">
              Solve a Full Year of Pickleball Lessons in Just 5 Minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}